(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cart-dialog]');
      this.root = window.Shopify?.routes?.root ?? '/';

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) return this.close();
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          this.change(remove.dataset.cartRemove, 0, remove.closest('.cart-item'));
          return;
        }
        // A click on the overlay lands on the dialog itself, outside the panel box
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
          if (!inside) this.close();
        }
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      // Header bag link and "In your bag" open the drawer instead of the cart page
      document.addEventListener('click', (event) => {
        const opener = event.target.closest('.cart-link__anchor, [data-cart-open]');
        if (!opener || event.metaKey || event.ctrlKey) return;
        event.preventDefault();
        this.open();
      });

      // Add to bag without leaving the page
      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
        event.preventDefault();
        this.add(form, event.submitter);
      });
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      // Start keyboard focus on the panel, so the close button shows no focus ring on open
      const panel = this.querySelector('[data-cart-content]');
      if (panel) {
        panel.tabIndex = -1;
        panel.focus({ preventScroll: true });
      }
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      const finish = () => {
        this.dialog.close();
        document.documentElement.style.overflow = '';
      };
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return finish();
      this.dialog.addEventListener('transitionend', finish, { once: true });
      setTimeout(() => this.dialog.open && finish(), 600);
    }

    /* Sections to re-render: this drawer plus any [data-cart-sync] block on the page */
    sectionIds() {
      const ids = new Set([this.dataset.section]);
      document.querySelectorAll('[data-cart-sync]').forEach((el) => ids.add(el.dataset.cartSync));
      return [...ids];
    }

    async renderSections(sections) {
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
      if (sections[this.dataset.section]) {
        const fresh = parse(sections[this.dataset.section]).querySelector('[data-cart-content]');
        if (fresh) this.querySelector('[data-cart-content]').replaceWith(fresh);
      }
      document.querySelectorAll('[data-cart-sync]').forEach((el) => {
        const html = sections[el.dataset.cartSync];
        const fresh = html && parse(html).getElementById(el.id);
        if (fresh) el.replaceWith(fresh);
      });
    }

    async add(form, submitter) {
      const button = submitter || form.querySelector('[type="submit"]');
      button?.setAttribute('aria-busy', 'true');
      const body = new FormData(form);
      body.append('sections', this.sectionIds().join(','));
      body.append('sections_url', window.location.pathname);
      try {
        const response = await fetch(`${this.root}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message);
        await this.renderSections(data.sections || {});
        this.announce();
        this.open();
      } catch (error) {
        // Fall back to the regular form post (shows Shopify's own message on the cart page)
        form.submit();
      } finally {
        button?.removeAttribute('aria-busy');
      }
    }

    async change(key, quantity, row) {
      row?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: this.sectionIds(), sections_url: window.location.pathname }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description);
        await this.renderSections(data.sections || {});
        this.announce(data.item_count);
        const panel = this.querySelector('[data-cart-content]');
        if (panel) {
          panel.tabIndex = -1;
          panel.focus({ preventScroll: true });
        }
      } catch (error) {
        window.location.href = `${this.root}cart/change?id=${encodeURIComponent(key)}&quantity=${quantity}`;
      }
    }

    async announce(itemCount) {
      let count = itemCount;
      if (typeof count !== 'number') {
        try {
          const cart = await (await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' } })).json();
          count = cart.item_count;
        } catch (error) {
          count = undefined;
        }
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: count } }));
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["commission-form"] && !Shopify.designMode) return;
  try {
    
  /*
   * Interest chips: each option shows its own hint in the message field.
   * Links from the product page preselect an option and prefill the message:
   * ?interest=1|2|3&message=…
   */
  (() => {
    const form = document.getElementById('CommissionForm');
    if (!form) return;
    const message = form.querySelector('.commission__textarea');
    const showHint = (radio) => {
      if (radio && radio.dataset.hint) message.placeholder = radio.dataset.hint;
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('.commission__chip-input')) showHint(event.target);
    });

    const params = new URLSearchParams(window.location.search);
    const interest = form.querySelector(`.commission__chip-input[data-interest="${params.get('interest')}"]`);
    if (interest) interest.checked = true;
    showHint(form.querySelector('.commission__chip-input:checked'));

    const prefill = params.get('message');
    if (prefill && !message.value) message.value = prefill;
  })();

  /* After a successful send: typing again clears the message and re-enables the button */
  document.addEventListener('input', (event) => {
    const form = event.target.closest('#CommissionForm');
    const success = form && form.querySelector('.commission__success');
    if (!success) return;
    success.remove();
    form.querySelector('.commission__note').hidden = false;
    form.querySelector('.commission__submit').disabled = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    let lastTrigger = null;

    const parts = () => ({
      menu: document.getElementById('MobileMenu'),
      overlay: document.querySelector('[data-menu-overlay]'),
      trigger: document.querySelector('[data-menu-open]'),
    });

    const isOpen = () => {
      const { menu } = parts();
      return Boolean(menu) && !menu.hidden;
    };

    const open = () => {
      const { menu, overlay, trigger } = parts();
      if (!menu || !overlay) return;
      lastTrigger = trigger;
      menu.hidden = false;
      overlay.hidden = false;
      trigger?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('menu-open');
      menu.querySelector('[data-menu-close]')?.focus();
    };

    const close = ({ restoreFocus = true } = {}) => {
      const { menu, overlay, trigger } = parts();
      if (!menu || menu.hidden) return;
      menu.hidden = true;
      if (overlay) overlay.hidden = true;
      trigger?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('menu-open');
      if (restoreFocus) (lastTrigger ?? trigger)?.focus();
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('[data-menu-open]')) {
        open();
      } else if (target.closest('[data-menu-close]') || target.closest('[data-menu-overlay]')) {
        close();
      } else if (target.closest('[data-menu-link]')) {
        close({ restoreFocus: false });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const { menu } = parts();
      const focusable = [...menu.querySelectorAll('button, a[href]')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    desktop.addEventListener('change', (event) => {
      if (event.matches) close({ restoreFocus: false });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /*
    Oil paint on the hero: the cursor lays thick strokes of pale beige-gold paint
    with horizontal bristle grooves and a glossy highlight; the paint sinks
    back into the dark canvas after a few seconds. When nobody moves the mouse (and on phones) an invisible
    brush scrapes slow strokes by itself. WebGL only; skipped under reduced motion.
  */
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    const NOISE = `
      float hash(vec2 p) { p = fract(p * vec2(123.34, 456.21)); p += dot(p, p + 45.32); return fract(p.x * p.y); }
      float noise(vec2 p) {
        vec2 i = floor(p), f = fract(p);
        vec2 u = f * f * (3.0 - 2.0 * f);
        return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x), mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y);
      }
      float fbm(vec2 p) {
        float v = 0.0, a = 0.5;
        for (int i = 0; i < 4; i++) { v += a * noise(p); p = p * 2.03 + 17.1; a *= 0.5; }
        return v;
      }
    `;

    const VERT = `
      attribute vec2 aPos;
      void main() { gl_Position = vec4(aPos, 0.0, 1.0); }
    `;

    // Mask: red = paint body (1 = full). Brush: a round loaded brush with a ragged
    // edge and streaks along the stroke.
    const SIM = `
      precision highp float;
      uniform sampler2D uPrev;
      uniform vec2 uRes;
      uniform vec2 uA;
      uniform vec2 uB;
      uniform float uRadius;
      uniform float uDraw;
      uniform float uDecay;
      ${NOISE}
      void main() {
        vec2 p = gl_FragCoord.xy;
        float m = texture2D(uPrev, p / uRes).r - uDecay;
        if (uDraw > 0.5) {
          vec2 ab = uB - uA;
          float len = length(ab);
          vec2 dir = len > 0.001 ? ab / len : vec2(1.0, 0.0);
          float t = clamp(dot(p - uA, dir) / max(len, 0.001), 0.0, 1.0);
          vec2 q = p - (uA + ab * t);
          float d = length(q);
          float side = dot(q, vec2(-dir.y, dir.x));
          float r = uRadius * (0.7 + 0.45 * noise(p * 0.04));
          float streak = 0.55 + 0.45 * noise(vec2(side * 0.18, dot(p, dir) * 0.012));
          float stamp = smoothstep(r, r * 0.45, d) * streak;
          m = max(m, stamp);
        }
        gl_FragColor = vec4(clamp(m, 0.0, 1.0), 0.0, 0.0, 1.0);
      }
    `;

    // Thick oil paint: the mask gives the paint body, bristle grooves run along the
    // stroke, paint piles up in a ridge at the edges; lit from the top left with a
    // glossy highlight, plus a soft sheen that follows the cursor. Behind the text
    // the paint is darker so the letters stay readable.
    const DRAW = `
      precision highp float;
      uniform sampler2D uMask;
      uniform vec2 uRes;
      uniform vec2 uMaskPx;
      uniform float uScale;
      uniform vec2 uLight;
      uniform vec4 uText[6];
      ${NOISE}
      float body(vec2 uv, vec2 px) {
        float m = texture2D(uMask, uv).r;
        float t = smoothstep(0.3, 0.62, m);
        float ridge = t * (1.0 - t) * 4.0;
        // Horizontal bristle grooves with a gentle wave, like the reference paintings
        vec2 g = vec2(px.x, px.y + 8.0 * noise(px * 0.008));
        float groove = 0.75 * noise(vec2(g.x * 0.005, g.y * 0.24)) + 0.25 * noise(vec2(g.x * 0.012, g.y * 0.6));
        return t * (0.78 + 0.22 * groove) + ridge * 0.55;
      }
      float boxDist(vec2 p, vec4 b) {
        vec2 c = (b.xy + b.zw) * 0.5;
        vec2 h = abs(b.zw - b.xy) * 0.5;
        vec2 d = abs(p - c) - h;
        return length(max(d, 0.0)) + min(max(d.x, d.y), 0.0);
      }
      void main() {
        vec2 uv = gl_FragCoord.xy / uRes;
        vec2 px = gl_FragCoord.xy / uScale;
        float m = texture2D(uMask, uv).r;
        float a = smoothstep(0.3, 0.38, m);
        if (a <= 0.001) { gl_FragColor = vec4(0.0); return; }

        // Relief from the paint body
        vec2 du = vec2(1.0 / uMaskPx.x, 0.0);
        vec2 dv = vec2(0.0, 1.0 / uMaskPx.y);
        vec2 dpx = 1.0 / (uMaskPx / uRes * uScale);
        float h = body(uv, px);
        float hx = body(uv + du, px + vec2(dpx.x, 0.0)) - h;
        float hy = body(uv + dv, px + vec2(0.0, dpx.y)) - h;
        vec3 n = normalize(vec3(-hx * 2.4, -hy * 2.4, 1.0));
        vec3 l = normalize(vec3(-0.45, 0.6, 0.65));
        float diff = 0.55 + 0.5 * dot(n, l);
        float spec = pow(clamp(dot(n, normalize(l + vec3(0.0, 0.0, 1.0))), 0.0, 1.0), 26.0);

        vec3 light = vec3(0.89, 0.83, 0.72);
        vec3 beige = vec3(0.72, 0.62, 0.48);
        vec3 brown = vec3(0.36, 0.27, 0.18);
        float tone = fbm(px * 0.004);
        vec3 col = mix(beige, light, smoothstep(0.3, 0.75, tone));
        float scratch = smoothstep(0.66, 0.84, noise(vec2(px.x * 0.006, px.y * 0.45)));
        col = mix(col, brown, scratch * 0.45);
        col *= diff;
        col += vec3(1.0, 0.97, 0.9) * spec * 0.45;

        // Cursor sheen catches the wet ridges
        vec3 lc = normalize(vec3(uLight - px, 260.0));
        float sheen = pow(clamp(dot(n, normalize(lc + vec3(0.0, 0.0, 1.0))), 0.0, 1.0), 40.0);
        col += vec3(1.0, 0.95, 0.85) * sheen * 0.35 * exp(-length(uLight - px) / 420.0);

        // Leftover dark paint along the edges
        col *= mix(0.5, 1.0, smoothstep(0.3, 0.55, m));

        // Darker behind the text
        float shade = 0.0;
        for (int i = 0; i < 6; i++) {
          shade = max(shade, 1.0 - smoothstep(-6.0, 26.0, boxDist(px, uText[i])));
        }
        col *= mix(1.0, 0.42, shade);

        gl_FragColor = vec4(col * a, a);
      }
    `;

    function init(hero) {
      if (hero.querySelector('.hero__gold')) return;
      const canvas = document.createElement('canvas');
      canvas.className = 'hero__gold';
      canvas.setAttribute('aria-hidden', 'true');
      const gl = canvas.getContext('webgl', { premultipliedAlpha: true, antialias: false });
      if (!gl) return;

      const compile = (type, source) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        return gl.getShaderParameter(shader, gl.COMPILE_STATUS) ? shader : null;
      };
      const program = (fragment) => {
        const vs = compile(gl.VERTEX_SHADER, VERT);
        const fs = compile(gl.FRAGMENT_SHADER, fragment);
        if (!vs || !fs) return null;
        const prog = gl.createProgram();
        gl.attachShader(prog, vs);
        gl.attachShader(prog, fs);
        gl.bindAttribLocation(prog, 0, 'aPos');
        gl.linkProgram(prog);
        if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return null;
        const uniforms = {};
        const count = gl.getProgramParameter(prog, gl.ACTIVE_UNIFORMS);
        for (let i = 0; i < count; i++) {
          const name = gl.getActiveUniform(prog, i).name;
          uniforms[name] = gl.getUniformLocation(prog, name);
        }
        return { prog, uniforms };
      };
      const sim = program(SIM);
      const draw = program(DRAW);
      if (!sim || !draw) return;

      hero.prepend(canvas);

      const quad = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, quad);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      gl.enableVertexAttribArray(0);
      gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);

      const MASK_SCALE = 0.5;
      let width = 0;
      let height = 0;
      let scale = 1;
      let targets = [];
      let read = 0;

      const makeTarget = (w, h) => {
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, w, h, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.clearColor(0, 0, 0, 1);
        gl.clear(gl.COLOR_BUFFER_BIT);
        return { texture, framebuffer };
      };

      // Text boxes in canvas pixels (y from the bottom, like the shader)
      const textBoxes = new Float32Array(24);
      const measureText = () => {
        textBoxes.fill(0);
        const origin = canvas.getBoundingClientRect();
        [...hero.querySelectorAll('.hero__line, .hero__statement')].slice(0, 6).forEach((element, index) => {
          const r = element.getBoundingClientRect();
          // Line boxes are taller than the letters; trim the top and bottom a little
          const trim = r.height * 0.12;
          textBoxes.set(
            [r.left - origin.left, height - (r.bottom - origin.top - trim), r.right - origin.left, height - (r.top - origin.top + trim)],
            index * 4
          );
        });
      };
      if (document.fonts) document.fonts.ready.then(() => measureText());

      // Cover the full screen width, from the top of the page to just below the hero
      const layout = () => {
        const page = document.documentElement.clientWidth;
        const rect = hero.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        width = page;
        height = Math.round(top + rect.height + 120);
        canvas.style.left = `${-rect.left}px`;
        canvas.style.top = `${-top}px`;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        scale = Math.min(window.devicePixelRatio || 1, 1.5);
        canvas.width = Math.round(width * scale);
        canvas.height = Math.round(height * scale);
        targets.forEach((target) => {
          gl.deleteTexture(target.texture);
          gl.deleteFramebuffer(target.framebuffer);
        });
        const mw = Math.max(1, Math.round(width * MASK_SCALE));
        const mh = Math.max(1, Math.round(height * MASK_SCALE));
        targets = [makeTarget(mw, mh), makeTarget(mw, mh)];
        read = 0;
        measureText();
      };
      layout();

      // Brush and light positions in CSS pixels from the canvas top left
      const brush = { x: 0, y: 0, px: 0, py: 0, active: false };
      const light = { x: width * 0.6, y: height * 0.4, tx: width * 0.6, ty: height * 0.4 };
      let lastInput = -1e9;
      const toCanvas = (event) => {
        const rect = canvas.getBoundingClientRect();
        return { x: event.clientX - rect.left, y: event.clientY - rect.top };
      };
      window.addEventListener(
        'pointermove',
        (event) => {
          const p = toCanvas(event);
          if (p.x < 0 || p.y < 0 || p.x > width || p.y > height) {
            brush.active = false;
            return;
          }
          if (!brush.active) {
            brush.px = p.x;
            brush.py = p.y;
          }
          brush.x = p.x;
          brush.y = p.y;
          brush.active = true;
          light.tx = p.x;
          light.ty = p.y;
          lastInput = performance.now();
        },
        { passive: true }
      );

      // Idle brush: a slow stroke every few seconds along a wandering path
      const ghost = { on: false, px: 0, py: 0 };
      const ghostAt = (t) => ({
        x: width * (0.5 + 0.36 * Math.sin(t * 0.37) + 0.08 * Math.sin(t * 1.3)),
        y: height * (0.42 + 0.26 * Math.sin(t * 0.53 + 1.2) + 0.06 * Math.cos(t * 1.7)),
      });

      let visible = true;
      let running = false;
      let last = 0;
      let accumulator = 0;
      let measured = 0;

      const step = (ax, ay, bx, by, drawing, decay) => {
        const source = targets[read];
        const dest = targets[1 - read];
        gl.bindFramebuffer(gl.FRAMEBUFFER, dest.framebuffer);
        const mw = Math.round(width * MASK_SCALE);
        const mh = Math.round(height * MASK_SCALE);
        gl.viewport(0, 0, mw, mh);
        gl.useProgram(sim.prog);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, source.texture);
        gl.uniform1i(sim.uniforms.uPrev, 0);
        gl.uniform2f(sim.uniforms.uRes, mw, mh);
        gl.uniform2f(sim.uniforms.uA, ax * MASK_SCALE, mh - ay * MASK_SCALE);
        gl.uniform2f(sim.uniforms.uB, bx * MASK_SCALE, mh - by * MASK_SCALE);
        gl.uniform1f(sim.uniforms.uRadius, (width < 1024 ? 46 : 74) * MASK_SCALE);
        gl.uniform1f(sim.uniforms.uDraw, drawing ? 1 : 0);
        gl.uniform1f(sim.uniforms.uDecay, decay);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        read = 1 - read;
      };

      const frame = (now) => {
        if (!visible) {
          running = false;
          return;
        }
        requestAnimationFrame(frame);
        const dt = Math.min((now - (last || now)) / 1000, 0.1);
        last = now;
        accumulator += dt;

        const idle = now - lastInput > 2500;
        const t = now / 1000;
        // Ghost strokes: 1.8s of painting, then 1.6s of rest
        const phase = t % 3.4;
        const ghostDrawing = idle && phase < 1.8;
        const g = ghostAt(t);
        if (idle) {
          light.tx = g.x;
          light.ty = g.y;
        }
        light.x += (light.tx - light.x) * 0.08;
        light.y += (light.ty - light.y) * 0.08;

        // Fixed 60 steps a second, so the paint flows back at the same speed on any screen
        let steps = 0;
        while (accumulator >= 1 / 60 && steps < 4) {
          accumulator -= 1 / 60;
          steps += 1;
          const userDrawing = brush.active && !idle;
          if (userDrawing) {
            step(brush.px, brush.py, brush.x, brush.y, true, 1.2 / 255);
            brush.px = brush.x;
            brush.py = brush.y;
          } else if (ghostDrawing) {
            if (!ghost.on) {
              ghost.px = g.x;
              ghost.py = g.y;
            }
            step(ghost.px, ghost.py, g.x, g.y, true, 1.2 / 255);
            ghost.px = g.x;
            ghost.py = g.y;
          } else {
            step(0, 0, 0, 0, false, 1.2 / 255);
          }
          ghost.on = ghostDrawing;
        }
        if (steps === 4) accumulator = 0;

        if (now - measured > 500) {
          measured = now;
          measureText();
        }

        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.viewport(0, 0, canvas.width, canvas.height);
        gl.useProgram(draw.prog);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, targets[read].texture);
        gl.uniform1i(draw.uniforms.uMask, 0);
        gl.uniform2f(draw.uniforms.uRes, canvas.width, canvas.height);
        gl.uniform1f(draw.uniforms.uScale, scale);
        gl.uniform2f(draw.uniforms.uMaskPx, Math.round(width * MASK_SCALE), Math.round(height * MASK_SCALE));
        gl.uniform4fv(draw.uniforms['uText[0]'], textBoxes);
        gl.uniform2f(draw.uniforms.uLight, light.x, height - light.y);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      };

      const start = () => {
        if (running || !visible) return;
        running = true;
        last = 0;
        requestAnimationFrame(frame);
      };

      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting && !document.hidden;
        start();
      }).observe(canvas);
      document.addEventListener('visibilitychange', () => {
        visible = !document.hidden;
        start();
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (document.documentElement.clientWidth !== width) layout();
        }, 150);
      });
      start();
    }

    const scan = () => document.querySelectorAll('.hero').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const card = document.querySelector('[data-pdp]');
    if (!card) return;
    const desktop = window.matchMedia('(min-width: 1024px)');

    /* Desktop: an info column taller than the screen scrolls first, then pins by its bottom */
    const info = card.querySelector('[data-pdp-info]');
    const updateSticky = () => {
      if (!desktop.matches) return info.style.removeProperty('--pdp-sticky-top');
      const header = document.querySelector('.site-header');
      const top = header ? header.getBoundingClientRect().bottom + 40 : 40;
      const fit = window.innerHeight - info.offsetHeight - 40;
      info.style.setProperty('--pdp-sticky-top', `${Math.min(top, fit)}px`);
    };
    new ResizeObserver(updateSticky).observe(info);
    window.addEventListener('resize', updateSticky);
    updateSticky();

    /* Mobile: progress bar follows the photo strip */
    const track = card.querySelector('[data-pdp-track]');
    const thumb = card.querySelector('[data-pdp-progress]');
    if (track && thumb) {
      track.addEventListener('scroll', () => {
        const max = track.scrollWidth - track.clientWidth;
        const count = track.children.length;
        const ratio = max > 0 ? track.scrollLeft / max : 0;
        thumb.style.setProperty('--progress', `${ratio * (count - 1) * 100}%`);
      }, { passive: true });
    }

    /* Zoom: open full screen at the chosen photo; click a photo to enlarge it more */
    const dialog = document.querySelector('[data-pdp-dialog]');
    if (!dialog) return;
    const images = dialog.querySelectorAll('[data-pdp-zoom-image]');

    card.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pdp-zoom]');
      if (!button) return;
      images.forEach((image) => { image.loading = 'eager'; });
      dialog.showModal();
      images[Number(button.dataset.pdpZoom)]?.scrollIntoView({ block: 'start' });
    });

    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-pdp-close]')) return dialog.close();
      const image = event.target.closest('[data-pdp-zoom-image]');
      if (!image) return;
      const zoomed = image.classList.toggle('is-zoomed');
      if (zoomed) {
        const rect = image.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        requestAnimationFrame(() => {
          const big = image.getBoundingClientRect();
          dialog.scrollBy(big.left + big.width * x - event.clientX, big.top + big.height * y - event.clientY);
        });
      }
    });

    dialog.addEventListener('close', () => {
      images.forEach((image) => image.classList.remove('is-zoomed'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
